import { RemoteCateringMenu } from "../../../../components/ServiceManagement/Catering/Domain/Types/Remote-CateringMenu.types";
import { useRemoteQuery } from "../../useRemote/useRemoteQuery";

/** GET /booking-services — optional locationId filters to that location plus unassigned rows (BE). */
export function useRemoteFetchAllCateringServices(locationId?: number | null, enabled?: boolean) {
  const isQueryEnabled = enabled ?? true;
  return useRemoteQuery<RemoteCateringMenu[]>({
    queryKey: ["booking-services", locationId ?? "all"],
    url: "/booking-services",
    params: locationId != null ? { locationId } : undefined,
    enabled: isQueryEnabled
  });
}
